import React from 'react';
import { Carousel } from 'react-bootstrap';
import img2 from '../../img/B-4 (2).jpg';
import img4 from '../../img/bg10.jpg';
import img1 from '../../img/bg9.jpg';
import img3 from '../../img/bg11.jpg';
import img5 from '../../img/bg-2.jpg';
import img6 from '../../img/bg15.jpg';
import './Header.css'

const Header = () => {
    return (
        <div className=''>
            <Carousel fade>
                <Carousel.Item>
                    <Carousel.Caption>
                        <h1 className="display-5 py-3 quote">WELCOME TO<br></br>PROPER Design & Development Limited</h1>
                    </Carousel.Caption>
                    <img
                    className="d-block w-100"
                    src={img6}
                    alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <Carousel.Caption>
                        <h1 className="display-5 py-3 quote">WE CONVERT DREAMS<br></br>INTO A REALITY!</h1>
                    </Carousel.Caption>
                    <img
                    className="d-block w-100"
                    src={img1}
                    alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <Carousel.Caption>
                        <h1 className="display-5 py-3 quote">WE SHAPE OUR BUILDINGS,<br></br>THEREAFTER, THEY SHAPE US</h1>
                    </Carousel.Caption>
                    <img
                    className="d-block w-100"
                    src={img2}
                    alt="Second slide"
                    />
                    {/* <Carousel.Caption>
                        <h3>Maintain proper BMI</h3>
                        <p>Clock's ticking</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                    <Carousel.Caption>
                        <h1 className="display-5 py-3 quote">YOU DREAM IT,<br></br>WE BUILD IT</h1>
                    </Carousel.Caption>
                    <img
                    className="d-block w-100"
                    src={img4}
                    alt="Third slide"
                    />
                    {/* <Carousel.Caption>
                        <h3>Want healthy mind?</h3>
                        <p>Don't be late to join</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                    <Carousel.Caption>
                        <h1 className="display-5 py-3 quote">SCIENTISTS DREAM ABOUT DOING GREAT THINGS,<br></br>ENGINEERS DO THEM</h1>
                    </Carousel.Caption>
                    <img
                    className="d-block w-100"
                    src={img3}
                    alt="Third slide"
                    />
                    {/* <Carousel.Caption>
                        <h3>Want healthy mind?</h3>
                        <p>Don't be late to join</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                    <Carousel.Caption>
                        <h1 className="display-5 py-3 quote">THE ROAD TO SUCCESS<br></br>IS ALWAYS UNDER CONSTRUCTION</h1>
                    </Carousel.Caption>
                    <img
                    className="d-block w-100"
                    src={img5}
                    alt="Third slide"
                    />
                    {/* <Carousel.Caption>
                        <h3>Want healthy mind?</h3>
                        <p>Don't be late to join</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
            </Carousel> 
        </div>
    );
};

export default Header;